/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_AudiencesInputs */

const en_directory_nav_audiences = /** @type {(inputs: Directory_Nav_AudiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiences`)
};

const zh_directory_nav_audiences = /** @type {(inputs: Directory_Nav_AudiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用人群`)
};

/**
* | output |
* | --- |
* | "Audiences" |
*
* @param {Directory_Nav_AudiencesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_audiences = /** @type {((inputs?: Directory_Nav_AudiencesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_AudiencesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_audiences(inputs)
	return zh_directory_nav_audiences(inputs)
});
export { directory_nav_audiences as "directory.nav.audiences" }